import React from 'react';
import { Button } from 'antd';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';

interface CodeValidStepProps {
  couponCode: string;
  onActivate: () => void;
  onClearCode?: () => void;
  resellerName?: string;
  resellerLogoUrl?: string;
}

const CodeValidStep: React.FC<CodeValidStepProps> = ({
  couponCode,
  onActivate,
  onClearCode,
  resellerName,
  resellerLogoUrl
}) => {
  return (
    <div className="activation-step">
      <div className="activation-step__content" style={{ alignItems: 'flex-start' }}>

        <p className="activation-step__subtitle"  style={{ textAlign: 'left', fontSize: '16px' }}>
          To get started with TruHu enter the {resellerName} activation code. <br/>
          Then create a TruHu account to enjoy good color made easy.
        </p>

        <div className="code-display code-display--valid code-display--compact" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span className="code-display__code" style={{ color: '#3f3f3f', textDecoration: 'none' }}>{couponCode}</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <CheckCircleFilled className="code-display__icon code-display__icon--valid" />
            {onClearCode && (
              <CloseCircleFilled 
                className="code-display__icon" 
                style={{ color: '#999', cursor: 'pointer' }}
                onClick={onClearCode}
              />
            )}
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}> 
        <p className="activation-step__hint" style={{ margin: '0px', textAlign: 'center' }}>
        Valid Code
        </p>

        </div>
        
        <Button
          type="primary"
          size="large"
          onClick={onActivate}
          className="activation-submit-btn"
          style={{ marginTop: '20px' }}
        >
          Activate
        </Button>

      </div>
    </div>
  );
};

export default CodeValidStep;
